__webpack_require__.p = "/clalit_accessibility_map/";